export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR';
export const fetchConfig = (name) => ({ type: FETCH_CONFIG, payload: name });

export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SAVE_CONFIG_SUCCESS = 'SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_ERROR = 'SAVE_CONFIG_ERROR';
export const saveConfig = (cfg) => ({ type: SAVE_CONFIG, payload: cfg });

export const CLEAR_CONFIG_ERROR = 'CLEAR_CONFIG_ERROR';
export const clearConfigError = () => ({ type: CLEAR_CONFIG_ERROR });

export const LIST_CONFIGS = 'LIST_CONFIGS';
export const LIST_CONFIGS_SUCCESS = 'LIST_CONFIGS_SUCCESS';
export const LIST_CONFIGS_ERROR = 'LIST_CONFIGS_ERROR';
export const listConfigs = (env) => ({ type: LIST_CONFIGS, payload: env });
